<template>
<div class="mapWindow" v-if="mapInfo">
     
     
      <VueDragResizeAndRotate v-if="true" :sticks=[] :resizable="false" :dragHandle="'.mapAdjustHeader'" style="border:none;background-color:transparent;z-index:1000;height:200px; width:500px;">
   
      <div style="height:200px; width:500px;   background-color:#000000aa; overflow: auto;" v-if="true">
   
      Center:{{ currentCenter }} zoom: {{ currentZoom }}
      Top Left : lat{{TLV}},lon{{TLH}} <br>
      Bottom Right : lat{{BRV}},lon{{BRH}} <br>
      <button @click="tlUp"> TL-UP </button>
       <button @click="tlDown"> TL-Down </button>
       <button @click="tlLeft"> TL-Left </button>
       <button @click="tlRight"> TL-Right </button>
       <br>
      <button @click="brUp"> BR-Up </button>
      <button @click="brDown"> BR-Down </button>
      <button @click="brLeft"> BR-Left </button>
      <button @click="brRight"> BR-Right </button>
      <br>
      <DxNumberBox
         :value.sync="stepValue"
        @value-changed="stepChanged"
        placeholder="stepAmount"
        :show-spin-buttons="true"
        width="100"
    />
    </div>
     </VueDragResizeAndRotate>
      <l-map v-if="mapInfo"
      ref="map"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      :style="'height: calc(100% - 30px); width: 100%'"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
       <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-image-overlay 
        :url="mapImage"
        :bounds="imageBounds"
        :attributionControl='false'
       
      />
     
   
     <div  v-for="(loc,l) in locationInfo" :key="'l'+l"> 
      <l-circle   v-if="locationInfo"
      :lat-lng="calcLoc(loc)"
      :radius="loc.radius"
      :color="loc.color"
      :fillOpacity=".2"
      :fillColor="'yellow'"
    />
    </div>
    <div  v-for="(loc,l) in locationInfo"  :key="'marker'+l">
      <l-marker
       :lat-lng="calcLoc(loc)"
       :icon="myIcon"
      >
     
        <l-popup :content="loc.name+' - '+loc.description" />
      </l-marker>
    
      </div>
      
     
     
    </l-map>
    <div v-if="false" class="debug">
      MAP INFO
  {{mapInfo}}
  </div>
      </div>
      
</template>

<script>
import Maps from '@/mixins/maps'
import { latLng } from "leaflet";
import DxNumberBox from 'devextreme-vue/number-box';

import VueDragResizeAndRotate from 'vue-drag-resize-and-rotate'

export default {
  mixins:[Maps],
  name: "Documents",
  components: {
    DxNumberBox,
    VueDragResizeAndRotate
  },
  props:{
    width:{default:300}
  },
  data() {
    return {
      stepValue:1,
      BRV:0,
      TLV:0,
      TLH:0,
      BRH:0,
     
      //center: latLng(47.41322, -1.219482),
        url:' https://api.mapbox.com/styles/v1/formula7/ck8az16v616us1ik95m20fy9n/draft/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZm9ybXVsYTciLCJhIjoiY2pybGVpeTh1MDdydzN5cjJ6aHo2cDlhMiJ9.na1OKOKSLJGOEDxHCuSzAw',
     
     // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      
      currentZoom: 12,
      currentCenter: latLng(-12.271573, 136.842957),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
      
    };
  },
  mounted(){
      this.setOffsets()
      this.$nextTick(() => {
        this.map=this.$refs.map.mapObject
        L.control.scale({imperial:false}).addTo(this.map);
        //this.currentZoom=this.mapInfo.zoom || 12
      //this.map.fitBounds(this.bounds);
      //this.$refs.map.mapObject.setView([70, 120], 1);
      })

  },
  computed:{
   
    mapID(){
      if(this.mapInfo){
        return this.mapInfo.id
      }
    },
    zoom(){
       if(this.mapInfo){
         return parseInt(this.mapInfo.zoom,10)
         return Math.floor(40000000/this.mapInfo.width)
       }
       return 12
    },
    stepDetail(){
      return Math.pow(10,this.stepValue-(this.zoom-1))
    },
    imageBounds(){
          if(this.mapInfo){
            return [[this.TLV,this.TLH],[this.BRV,this.BRH]]
          }
      return [[-12.159387,136.782969], [-13,138]]
    },
    center(){
          if(this.mapInfo){
            //return latLng(-12.3024901,136.7290677)
            return latLng((this.mapInfo.tl.lat+this.mapInfo.br.lat)/2,(this.mapInfo.tl.lon+this.mapInfo.br.lon)/2)
          }
       return latLng(-12.271573, 136.842957)
     },
    minZoom(){
      if(this.mapInfo){
         return Math.floor( -this.mapInfo.width/5000) || -10
      }
     retturn -10
    },
    mapSize(){
      if(this.mapInfo){
        return this.mapInfo.width || 5000
      }
      return 5000
    },
    getMapZones(){
      return this.$store.getters.getMapZones("map001")
    },
    getLocations(){
      let locs=[]
      for(var l in this.mapInfo.locations ){
        this.$store.dispatch('loadLoc',this.mapInfo.locations[l].id)
        locs.push(l)
      }
      return locs
      
    },
   
    mapInfo(){
      console.log(this.$store.getters.getCurrentMap)
      return this.$store.getters.getCurrentMap
    },

     mapImage(){
      if(this.mapInfo.image){
        let mapInfo=this.mapInfo.image.split("|")

        if(mapInfo.length>0){
          return mapInfo[1]
        }
        return require("../assets/images/maps/"+this.mapInfo.image) 
      }
        return null
      
    },
    
    bounds(){
      return [[Math.floor(-this.mapSize*.5),Math.floor(-this.mapSize*.5*this.ratio)], [Math.floor(this.mapSize*.5),Math.floor(this.mapSize*.5*this.ratio)]]
    },
    maxBounds(){
      return [[Math.floor(-this.mapSize*.5),Math.floor(-this.mapSize*.5*this.ratio)], [Math.floor(this.mapSize*.5),Math.floor(this.mapSize*.5*this.ratio)]]
  
    },
    myIcon(){
      return L.divIcon({className: 'mIcon'})
    },
    
  },
  methods:{
    closeMap(){
      this.$emit('hideMap')
    },
    setOffsets(){
      this.TLV=this.mapInfo.tl.lat
      this.TLH=this.mapInfo.tl.lon
      this.BRV=this.mapInfo.br.lat
      this.BRH=this.mapInfo.br.lon
      
    },
    stepChanged(){
      //alert("CHANGE")
    },
    tlDown(){
      this.TLV-=.01/this.stepDetail
    },
    tlUp(){
      this.TLV+=.01/this.stepDetail
    },
    tlLeft(){
      this.TLH-=.01/this.stepDetail
    },
    tlRight(){
      this.TLH+=.01/this.stepDetail
    },
    brDown(){
      this.BRV-=.01/this.stepDetail
    },
    brUp(){
      this.BRV+=.01/this.stepDetail
    },
    brLeft(){
      this.BRH-=.01/this.stepDetail
    },
    brRight(){
      this.BRH+=.01/this.stepDetail
    },
    calcLoc(loc){
     // console.log("CALC LOC",loc)
       let newLoc={}
       
           newLoc.lat=loc.lat
           newLoc.lng=loc.lon
           // console.log("CALC LOC",newLoc)
           return newLoc
        
       
    },
    calcZone(zone){
      console.log("ZONE",zone,this.mapInfo)
      let newZone={}
      if(this.mapInfo){
        newZone.lat=zone.lat
        newZone.lng=zone.lng
       // newZone.lat=(zone.lat-this.mapInfo.tl.lat)*this.mapInfo.width/10000-this.mapInfo.width/2
       // newZone.lng=(zone.lng-this.mapInfo.tl.lon)*this.mapInfo.width/1000+this.mapInfo.width/2
        console.log("New Zone",newZone)
        return newZone
      }
      return zone
    },
    doResize(){
      
      this.$refs.map.mapObject.invalidateSize()
    },
    activatePanel(){
       console.log("MAPA",this.$refs.map.mapObject)
     
      this.$refs.map.mapObject.invalidateSize()
      this.$emit('activateMap')
    },
    zoneStyle(zone){
      
      return "top:"+zone.lat+"px;left:"+zone.lng+"px;width:"+zone.size+"px;height:"+zone.size+"px;"
    },
    doUpdate(evnt,elm){
     console.log("Center Update",evnt)
     this.$emit('mapChange',this.currentZoom,this.currentCenter)
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
      this.doUpdate()
    },
    centerUpdate(center) {
      this.currentCenter = center;
      this.doUpdate()
    },
  },
  watch:{
    mapID(val){
      
    },
    mapInfo(val){
     if(val && this.$refs.map){
        this.setOffsets()
      this.$refs.map.mapObject.setView(L.latLng(this.center.lat, this.center.lng), val.zoom);
      this.doResize()
     }
     
     
     
    },
    center(val){
     
      this.currentCenter=val
    }
  }
};
</script>

<style>
.leaflet-control-attribution{
  display:none;
}
.map {
  position:relative;
  width: 100%;

}
.mapImage{
  position: relative;
  overflow: hidden;
  width:100%;
  height:600px;
  background-size: cover;
  
}
.zone{
  position:absolute;
  top:200px;
  left:200px;
  width:300px;
  height:300px;
  background-color:#ff8d0070;
  border: #00ffff solid 2px;
  border-radius:50%;
}

.mIcon{
  width:10px!important;
  height:10px!important;
  border-radius:100%;
  background-color:#f90;
  
}
.mapWindow{
  background-color:#00ffff;
  box-shadow: inset 0px 0px 50px 0px;
}
</style>